module.exports = __webpack_public_path__ + "img/ep-chauve-souris.bbe655fd.jpg";